import type { StartParams } from "@/shared/router"

export type UsageEntry =
  | "onboarding"
  | "captcha"
  | "report"
  | "shared_stats"
  | "auto_message"
  | "tab_link"
  | "chat_link"
  | "plain"
  | "resume"

export const classifyEntry = (params: StartParams): UsageEntry => {
  if (params.onboardingButton !== null) return "onboarding"
  if (params.captchaMode || params.joinRequestAttemptId !== null) return "captcha"
  if (params.reportId !== null) return "report"
  if (params.shareToken !== null) return "shared_stats"
  if (params.autoMessageId !== null) return "auto_message"
  if (params.tabParam !== null) return "tab_link"
  if (params.chatId !== null) return "chat_link"
  return "plain"
}
